// src/lib/utils.js
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function createPageUrl(pageName) {
  const routes = {
    Home: '/',
    Reservation: '/reservation',
    AdminLogin: '/admin-login',  // Add this mapping
    AdminDashboard: '/admin-dashboard',  // Update this to match your route
  };
  
  return routes[pageName] || '/';
}